module.exports = __webpack_public_path__ + "img/sudoku-haze.1a6bd260.svg";